import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const classes=  {
    h1 : {
        margin:'left',
        align:'left',
        justify:'left',
        color: '#009688',
        paddingTop:20,
        width:'100%',
        marginBottom:20,
        marginTop:50,
        borderTop: 'solid 0.03em',
        },
    h2 : {
    margin:'auto',
    align:'left',
    justify:'left',
    color: '#009688',
    paddingBottom:30,
    borderBottom: 'solid 0.04em',
    width:'100%',
    marginBottom:60,
    fontStyle:'italic'
    },
    p: {
       color: '#4A4A4A',
       marginBottom: 20
    },
    p1: {
        color: '#4A4A4A',
        marginBottom: 20,
        fontWeight: 'bold'
     }
}
export class Info extends Component {
    render() {
        return ( 
            <div align="left" style={{margin:'7%'}}>
               
              
<Typography variant="h3" style={classes.h1}>
                   Lunch
                </Typography>
                
                <Typography style={classes.p}>
                    On Monday June 6 lunch will be served in the lunch room of the mathematics department. At other days we suggest the following places:
                </Typography>
           
                <Typography style={classes.p} >
                On campus:
<ul>
    <li>
    Syster o Bror, Drottning Kristinas vägen 24, <Link href="https://systerobror.se/"> webpage</Link> and <Link href="https://g.page/restaurangsysterobror?share">directions</Link>
    </li>
    <li>
    Restaurant Q, Malvinas vägen 4, <Link href="https://www.tastebynordrest.se/"> webpage</Link>and   <Link href="https://goo.gl/maps/1RCAQA7vmUyC8Q649">directions</Link>

    </li>
    <li>
    Ostrastation inside train station, Drottning Kristinas vägen 1,  <Link href="https://ostrastation.se/"> webpage</Link>  and <Link href="https://goo.gl/maps/YfHcxSCYdq41zkSt6">directions</Link>

    </li>
    <li>
    Stories Cafe inside KTH Library,<Link href="https://storiescafe.se/kth/"> webpage</Link> and  <Link href="https://goo.gl/maps/JoC8gkdn2q1kqwSdA"> directions </Link> (for a quick lunch)

    </li> 
    </ul>



                </Typography>
            
                <Typography style={classes.p}>
                There are many off campus restuarants in Stockholm and almost all of them give a special lunch deal (often between 100SEK and 150SEK).  We name a few standard places but there are many more (often not suited for larger groups): 

<ul>
    <li>
    Restaurang Cypern, Mediterranean, Valhallavägen 50,  <Link href="https://restaurangcypern.se/"> webpage</Link> and <Link href="https://goo.gl/maps/hrLQ2m5hYQfLtNmRA">directions </Link> (not suited for larger groups)
    </li>
    <li>
    Flying Fish, Japanese and Korean,  Danderydsgatan 23,  <Link href="https://www.flyingfish23.com/"> webpage</Link> and <Link href="https://goo.gl/maps/USVmAgu1SAioLCMf7">directions </Link> (not suited for larger groups)
    </li>
    <li>
    Forno Romano, Pizza and Pasta, Danderydsgatan 25,  <Link href="https://goo.gl/maps/oVvcUjTY6J59iFwE9"> directions</Link>  (not suited for larger groups)
    </li>
    <li>
    Spice of India, Sturegatan 29  <Link href="https://spiceofindia.se/"> webpage</Link> and <Link href="https://goo.gl/maps/wJpQGRgt9imaTWBeA"> directions </Link> (possibly a wait for larger groups)
    </li>
    <li>
    Bullar o  Bröd, bakery, Valhallavägen 65, <Link href="https://www.bullarochbrod.se/"> webpage</Link> and  <Link href="https://goo.gl/maps/7bPXK5JrPjT5MBsd8"> directions </Link> (for a quick lunch or take away)
    </li>
    </ul>
                </Typography>


                <Typography variant="h3" style={classes.h1}>
                   Maps and directions 
                </Typography>

                <Typography style={classes.p} >
                 After arriving at Arlanda there are basically three ways of getting to KTH and Stockholm: <Link href="https://www.flygbussarna.se/"> Bus</Link> (flygbus 139 SEK, discount on pre-order), <Link href="https://www.arlandaexpress.se"> High-speed train </Link> (Arlanda Express 299 SEK single ticket, but cheaper when travelling in a group) (Please note that there is a disruption for the Arlanda express June 4-6) or Taxi (around 695 SEK). Note that there is a separate taxi line for electric vehicles. 
                 </Typography>
                <Typography style={classes.p} >
                <Link href="https://www.kth.se/math/people/find-us-1.833819">Directions</Link> to the Mathematics Department  
                </Typography>

                <Typography style={classes.p} >
                    Stockholm has an excellent public transportation system. It is very convenient travelling by subway or bus. Single tickets are 39SEK and valid for 1h15min, but you may want to invest in a 3-day or 7-day pass. Some of the ferries (but not all) are included. See the homepage of 
                <Link href="https://sl.se/en/in-english"> SL </Link> for more information and a journey planner. 
                </Typography>

                <Typography variant="h3" style={classes.h1}>
                   Travelling to and from Sweden during pandemic
                </Typography>
                <Typography style={classes.p}>
                The latest regulations concerning travelling to and from Sweden during the pandemic can be found <Link href="https://www-front01.krisinformation.se/en/hazards-and-risks/disasters-and-incidents/2020/official-information-on-the-new-coronavirus/travel-restrictions">
                here. </Link>  All border sanitary measures have been lifted. Wearing of facial masks is not required in public transportation. 
                </Typography>
                <Typography style={classes.p1}>
                Covid tests: For your return flight you may need to present a negative covid test result depending on your destination. Current rules are found <Link href="https://www.iatatravelcentre.com/world.php">here</Link>
                </Typography>
                <Typography style={classes.p}>
The closest test opportunity in Stockholm is at the pharmacy `Apoteksgruppen' located on Birger Jarlsgatan 53 <Link href="https://goo.gl/maps/R3B42JDAWe4YV5GE8"> (directions) </Link>. Registration through the web page <Link href="https://reseintyg.vaccina.se/tidsbokning/#/service">`Vaccina' (Stockholm, Birger Jarlsgatan) </Link>  is required.    Note that this test location has restricted opening hours (10am-6pm) and is closed on weekends.
</Typography>
                <Typography style={classes.p}>
Another test location, open till 8pm everyday, is located at Drottninggatan 82 <Link href="https://goo.gl/maps/UjQnhMi5mQxmQFeMA">(directions)</Link>. Registration through the webpage <Link href="https://reseintyg.vaccina.se/tidsbokning/#/service "> `Vaccina' </Link> --> Stockholm, Drottninggatan 82. At this test location travelers on SAS flights profit from a discount using  <Link href="https://reseintyg.vaccina.se/sas/tidsbokning/#/service">the registration link</Link>. SAS discount is not offered at Birger Jarlsgatan.
</Typography>
                <Typography style={classes.p}>
                At Arlanda Airport there are several providers. For example, <Link href=" https://expresscare.se/boka-coronatest/">  `Expresscare' </Link>, open 24hours, located in `Sky-City' between terminals 4 and 5 on the ground floor,  <Link href="https://goo.gl/maps/C8FfyZwsWT6LkEF68">directions.</Link>  Travelers on SAS flights may book through <Link href="https://expresscare.se/partner/sas-arlanda/">this link</Link> for a discount. We do not recommend testing at the airport as test locations are not directly located at check-in or usual drop-off locations.
</Typography>
                <Typography style={classes.p}>
Note that at check-in further documentation may be  <Link href= "https://www.iatatravelcentre.com/world.php">required </Link>. For example, for flights to the US a signed CDC passenger attestation form needs to be presented by all passengers (see <Link href="https://www.cdc.gov/quarantine/pdf/NCEZID-combined-disclosure-attestation-en-508.pdf">info</Link>). Non US nationals/residents need to present proof of vaccination. Passengers to Canada must present an <Link href="https://travel.gc.ca/travel-covid/travel-restrictions/wizard-start#services" >ArriveCAN receipt</Link>  at check-in/boarding.  </Typography>
<Typography variant="h3" style={classes.h1}>
                   Network
                </Typography>
                

                <Typography style={classes.p} >
                    We recommend to use Eduroam for WiFi connections. <br></br>
                    If you can not connect to Eduroam, then please contact the organizers and we will give you a guest account.
                </Typography>
                
                <Typography variant="h3" style={classes.h1}>
                   Things to do and see in Stockholm
                </Typography>
                

                <Typography style={classes.p} >
                A good source of information on restaurants, pubs and cultural activities in Stockholm is 
              <Link href="https://thatsup.co/stockholm/?_ga=2.197681447.904245902.1643978182-2036050447.1643978182"> Thatsup </Link>
                </Typography>

                <Typography style={classes.p}>
                    A few restaurant suggestions:
                    <ul>
                        <li>
                        <Link href="https://unpoco.se/" >Un Poco</Link>
                        </li>
                        <li>
                        <Link href="https://bar-bro.se/" >Barbro</Link>
                        </li>
                        <li>
                        <Link href="https://teatergrillen.se/" >Teatergrillen</Link>
                        </li>
                        <li>
                        <Link href="https://www.kungcarl.se/bistro-la-belle-epoque" >Bistro La Belle Epoque</Link>
                        </li>
                        <li>
                        <Link href="https://berns.se/sv/restaurants/berns-asiatiska/" >Berns Asiatiska</Link>
                        </li>
                        <li>
                        <Link href="https://www.restaurangsensum.se/" >Resturang Sensum</Link>
                        </li>
                        <li>
                        <Link href="https://aifur.se/" >Aifur (Viking restaurant)</Link>
                        </li>
                        <li>
                        <Link href="https://paganini.nu/" >Paganini</Link>
                        </li>
                        <li>
                        <Link href="https://www.animorestaurant.se/" >Animo</Link>
                        </li>
                        <li>
                        <Link href="https://www.doma.se/" >Doma</Link>
                        </li>

                        <li>
                        <Link href="https://www.lepetitcochon.se/" >Le Petit Cochon</Link>
                        </li>
                        <li>
                        <Link href="https://omaka.beer/" >Omaka</Link>
                        </li>
                        <li>
                        <Link href="https://spesso.se/" >Spesso</Link>
                        </li>
                        <li>
                        <Link href="https://misshumasshu.se/" >Misshumasshu</Link>
                        </li>
                        <li>
                        <Link href="https://www.patsplace.se/" > Pat’s place (Thai tapas restaurant)</Link>
                        </li>
                        <li>
                        <Link href="https://www.capitolbio.se/bistro/" >Bistro Capitol (Art deco style place)</Link>
                        </li>
                        <li>
                        <Link href="https://restaurantetoile.se/" >Etoile (fine dining)</Link>
                        </li>
                        <li>
                        <Link href="https://ichisthlm.se/" >Ichi (Japanese)</Link>
                        </li>
                        <li>
                        <Link href="https://hotelatsix.com/sv/restaurang-barer/dining-room/" >Dining room At Six</Link>
                        </li>
                        <li>
                        <Link href="https://www.kagges.com/" >Kagges</Link>
                        </li>
                        <li>
                        <Link href="https://baragrikultur.com/" >Agrikultur Bar</Link>
                        </li>
                        <li>
                        <Link href="https://sushioi.se/" >Sushi Oi</Link>
                        </li>
                        <li>
                        <Link href="https://www.birdsthlm.com/" >Bird (Budget but good)</Link>
                        </li>
                    </ul>
                </Typography>
            </div>
            )
        }
    }


export default Info;